define('services/CouponCodeUnpagedService',[
    'app',
    'modules/module',
    'services/EntityCrudUnpagedService'
], function (app, module) {
    'use strict';
    return module.factory('CouponCodeUnpagedService', [
        '$injector',
        CouponCodeUnpagedService
    ]);
});


function CouponCodeUnpagedService($injector) {

    crudInstance = $injector.instantiate(EntityCrudUnpagedService);
    crudInstance.setType('CouponCode');

    angular.extend(this, crudInstance);

    return this;
};
